
export enum RelevantDayType {
    Holiday = 'Holiday',
    LeaveFullDay = 'LeaveFullDay',
    LeaveHalfDay = 'LeaveHalfDay',
    LeavePendingDay = 'LeavePendingDay',
}
